// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.gray[data-v-650d9a5a] {\n\tcolor: var(--main-gray-4);\n}\n.checkmark[data-v-650d9a5a] {\n\tfont-size: 40px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
